import React from 'react';
import CarouselComponent from 'components/carousel/Carousel';
import SponsorTab from '../../components/sponser-tab/SponsorTab';
import { sponsorData } from '../../data/SponsorData';
import MarketplaceSection from 'components/home-sections/marketplace-section/MarketplaceSection';
import ClimateTradeStats from 'components/home-sections/climate-trade/ClimateTrade';
import TrendingProjectsSection from 'components/home-sections/trending-projects-section/TrendingProjectsSection';
import CalculatorSection from 'components/home-sections/calculator-section/CalculatorSection';
import CollaborationsSection from 'components/home-sections/colloborators-section/ColloboratorsSection';
import Divider from 'components/divider/Divider';
import { useTranslation } from 'react-i18next';
import TakeAction from 'components/home-sections/take-action/takeAction';
import CarbonCertificate from 'components/home-sections/climate-trade/carbon-certificate/CarbonCertificate';
import CarbonSustain from 'components/home-sections/carbon-sustain/CarbonSustain';
import StatsSection from 'components/stats-section/stats-section';
import FeaturesSection from 'components/feature-section/FeaturesSection';
import CertificatePdf from 'components/certificate/CertificatePdf';
import ActivitiesList from 'components/cards/activities-card/ActivitiesCard';
import { activitiesData } from 'data/HomePageActivitiesData';
import styles from './Home.module.scss';
import HeadingText from 'components/text/HeadingText';

const Home = () => {
  const { t } = useTranslation(); // Move inside the component

  // Define the carousel items with translated text
  const carouselItems = [
    {
      image: '/bg/carousel5.png',
      text: t('carouselText1'), // Using translation key
    },
    {
      image: '/bg/carousel6.jpg',
      text: t('carouselText2'),
    },
    {
      image: '/bg/carousel8.png',
      text: t('carouselText3'),
    },
    {
      image: '/bg/carousel9.jpg',
      text: t('carouselText4'),
    },
  ];

  return (
    <div>
      {/* Home Page Content */}
      <CarouselComponent items={carouselItems} />
      <CarouselComponent items={[]} />
      <SponsorTab sponsors={sponsorData} />

      <MarketplaceSection />
      <Divider />
      <ClimateTradeStats />
      <TrendingProjectsSection />
      <StatsSection />
      <CarbonCertificate />
      <Divider />
      <TakeAction />
      <Divider />
      <HeadingText text={'Our Activities'} align='center' />
      <div className={styles.activitiesWrapper}>
        <ActivitiesList activities={activitiesData} className={styles.activitiesList} />
      </div>
      <FeaturesSection />
      <Divider />
      <CarbonSustain />
    </div>
  );
};

export default Home;
